import toCamelCase from '../toCamelCase';

export default function getChaptersBlockData(props) {
  const {
    fields: { theProblem, theHypothesis, theSolution },
  } = props;

  const data = {};
  // change

  data.chapters = theProblem || theHypothesis || theSolution ? [] : false;
  if (data.chapters) {
    const problemChapter = theProblem ? {} : false;
    if (problemChapter) {
      problemChapter.title = 'The Problem';
      problemChapter.id = toCamelCase(problemChapter.title);
      problemChapter.figure = '#figure-problem';
      problemChapter.content = theProblem;
      data.chapters.push(problemChapter);
    }

    const hypothesisChapter = theHypothesis ? {} : false;
    if (hypothesisChapter) {
      hypothesisChapter.title = 'The Hypothesis';
      hypothesisChapter.id = toCamelCase(hypothesisChapter.title);
      hypothesisChapter.figure = '#figure-hypothesis';
      hypothesisChapter.content = theHypothesis;
      data.chapters.push(hypothesisChapter);
    }

    const solutionChapter = theSolution ? {} : false;
    if (solutionChapter) {
      solutionChapter.title = 'The Solution';
      solutionChapter.id = toCamelCase(solutionChapter.title);
      solutionChapter.figure = '#figure-solution';
      solutionChapter.content = theSolution;
      data.chapters.push(solutionChapter);
    }
  }

  return Object.keys(data).length ? data.chapters : false;
}
